import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { MAX_UPLOAD_SIZE, getUploadRejection, uploadAccept } from 'src/app/core/media-upload';
import { DirectMediaUploadService, uploadErrorMessage } from 'src/app/core/direct-media-upload.service';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss'],
})
export class UploadImageComponent implements OnInit {

  @Input() labelText: string;
  UPLOAD_SIZE_LIMIT = MAX_UPLOAD_SIZE;
  readonly UPLOAD_ACCEPT = uploadAccept('image');

  // Optional, caller-provided validation rules. When set, override / supplement
  // the default UPLOAD_SIZE_LIMIT and add dimension checks.
  @Input() maxWidth?: number;
  @Input() maxHeight?: number;
  @Input() minWidth?: number;
  @Input() minHeight?: number;
  @Input() maxBytes?: number;

  dragAreaClass: string;
  draggedFiles: any;

  imgTooHeavy = false;
  imgTooHeavyMsg = '';

  imagePath: any;
  imgURL: any;
  message: string;
  onerror = [];
  mediaTab = 1;

  store_id;
  photo;
  uploadedImage;
  medias: any = [];
  bearer;
  body = [];
  media_id;

  closeResult = '';

  data = [];
  media_photo;

  title;
  caption;
  alt_text;
  filesize;
  save_photo;

  isSavingImage = false;

  constructor(
    private svc: StoreService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private uploader: DirectMediaUploadService,
    public utils: UtilitiesService
  ) { }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    this.getMedia();
  }

  async SaveIMG() {
    const { mediaTab } = this;

    if (mediaTab === 1 && (!this.imgURL || !this.files[0])) {
      return;
    }

    if (mediaTab === 1) {
      // Set uploading mode
      this.isSavingImage = true;

      try {
        const media = await this.uploader.upload(this.files[0]);
        this.activeModal.close([media['photo'], media['media_id']]);
      } catch (error) {
        const reason = uploadErrorMessage(error);
        this.utils.notify.showError(
          reason ? this.utils.translate(reason) : this.utils.translate('Upload Failed!'),
          this.utils.translate('Upload Failed!')
        );
      } finally {
        this.isSavingImage = false;
      }
    }
  }

  getMedia() {
    this.svc.getMediaList(this.bearer).subscribe((res) => {
      console.log(res);
      let response = res['data'] ?? [];
      let mediaData = typeof response !== 'object' ? [] : response;
      console.log('this.medias 1', this.medias);

      this.medias = mediaData.sort((a, b) => {
        return +b.media_id - +a.media_id;
      });

      console.log('this.medias 2', this.medias);
    });
  }

  preview(files: any) {
    if (files.length === 0) {
      console.log(files[0].size, files[0].name, files[0].type);
      return;
    }

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      //this.uploadedImage = reader.result;
      //console.log('PHOTTTTOOOO',this.uploadedImage);
    };
  }

  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  switchMediaTab(e) {
    this.mediaTab = parseInt(e.index) + 1;
  }

  setErrorImg(e, media_id) {
    this.onerror[media_id] = true;
    e.target.src =
      'https://cdn.estore5s.com/asset/images/estore_missing_product.png';
  }

  imageSelect(photo, media_id) {
    console.log({ photo, media_id });
    if (this.onerror[media_id]) {
      return;
    }

    this.imgURL = photo;
    this.media_photo = media_id;
    this.data = [];
    this.data.push(this.imgURL);
    this.data.push(this.media_photo);
  }

  uploadImage() {
    if (this.mediaTab === 1) {
      return;
    }
    this.activeModal.close(this.data);
  }

  files: File[] = [];

  async onSelect(event) {
    this.imgURL = '';

    this.imgTooHeavy = false;
    this.imgTooHeavyMsg = '';

    this.files = [];

    // Files outside UPLOAD_ACCEPT arrive in rejectedFiles; check them too so they get a message.
    const file: File = event.addedFiles[0] ?? event.rejectedFiles?.[0];
    if (!file) {
      return null;
    }

    // Effective size limit: caller override beats the component default.
    const sizeLimit = this.maxBytes ?? this.UPLOAD_SIZE_LIMIT;
    const rejection = await getUploadRejection(file, 'image', sizeLimit);
    if (rejection) {
      this.imgTooHeavy = true;
      this.imgTooHeavyMsg = this.utils.translate(rejection.key, rejection.values);

      return null;
    }

    // Allowed file size. Original synchronous preview path — preserved as-is
    // so callers that don't request dimension validation (i.e. every existing
    // user of this component) behave identically to before.
    this.files.push(...event.addedFiles);
    var reader = new FileReader();
    this.imagePath = this.files;
    reader.readAsDataURL(this.files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      this.media_photo = reader.result;
      this.data.push(this.files[0].name.slice(0, -4));
      this.data.push(this.files[0].size);
      this.data.push(this.imgURL);

      // Only run dimension checks when caller opted in by passing rules.
      // Without rules, this branch is skipped entirely.
      if (this.hasDimensionRules()) {
        this.checkImageDimensions(reader.result as string).catch(
          (reason: { key: string; values: any[] }) => {
            // Revert preview state and surface the validation error.
            this.imgTooHeavy = true;
            this.imgTooHeavyMsg = this.utils.translate(
              reason.key,
              reason.values
            );
            this.imgURL = '';
            this.media_photo = '';
            this.files = [];
            this.data = [];
          }
        );
      }
    };
  }

  private hasDimensionRules(): boolean {
    return Boolean(
      this.minWidth || this.minHeight || this.maxWidth || this.maxHeight
    );
  }

  /**
   * Resolves when the image satisfies the optional caller-provided dimension
   * rules. Rejects with a translation key + values describing which rule failed.
   * If no dimension rules are set, always resolves.
   */
  private checkImageDimensions(
    src: string
  ): Promise<void> {
    const minW = this.minWidth;
    const minH = this.minHeight;
    const maxW = this.maxWidth;
    const maxH = this.maxHeight;

    if (!minW && !minH && !maxW && !maxH) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const w = img.naturalWidth;
        const h = img.naturalHeight;

        if ((minW && w < minW) || (minH && h < minH)) {
          return reject({
            key: 'Image is too small ({0}×{1}). Minimum dimensions are 200×200 pixels.',
            values: [w, h],
          });
        }
        if ((maxW && w > maxW) || (maxH && h > maxH)) {
          return reject({
            key: 'Image is too large ({0}×{1}). Maximum dimensions are 1200×630 pixels.',
            values: [w, h],
          });
        }
        resolve();
      };
      img.onerror = () =>
        reject({
          key: 'Could not load the selected image. Please try a different file.',
          values: [],
        });
      img.src = src;
    });
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
    this.data = [];
    this.imgURL = '';
    this.media_photo = '';
    this.save_photo = '';
  }

  get isUploading() {
    return this.isSavingImage;
  }
}
